import React, { Component } from 'react';
import GlobalPlayerContext from './context';

class GlobalPlayerProvider extends Component {
  showPlayer = source => {
    if (this.state.playing) {
      this.setState({
        playing: true,
        source: source,
      });
    } else {
      this.setState({
        playing: true,
        source: source,
      });
    }
  };
  setPlayerId = () => {};
  hidePlayer = () =>
    this.setState({
      playing: false,
      source: null,
    });

  state = {
    playing: false,
    source: null,
    playerId: null,
    showPlayer: this.showPlayer,
    hidePlayer: this.hidePlayer,
  };

  render() {
    return (
      <GlobalPlayerContext.Provider value={this.state}>
        {this.props.children}
      </GlobalPlayerContext.Provider>
    );
  }
}

export default GlobalPlayerProvider;
